export const devEnv = {
  VITE_ENV: 'development',
  VITE_AZURE_ENV: 'int',

  VITE_PLATFORM_REST_ENDPOINT: 'https://portal-api.int.artbasel.app/api-int',
  VITE_X_API_KEY: 'portal_api_int_1c432dd045af6a3209703dde00811171',
  VITE_SERVER_EVENTS_PREFIX: 'https://portal-api.int.artbasel.app/api-int',

  VITE_AUTH_TOKEN_KEY: 'auth-token-dev',
  VITE_AUTH0_CLAIMS_NAMESPACE: 'https://arcual-access.com',
  VITE_AUTH0_CLAIMS_NAMESPACE_MCH: 'https://mch-aim-dev',

  VITE_STOREFRONT_URL: 'int.artbasel.app',
  VITE_PLATFORM_URL: 'https://portal.int.artbasel.app',

  VITE_IMG_PROXY_URL: 'https://cdn.development.arcual.art',
  VITE_PROFILE_IMG_PROXY_BUCKET: 's3://arcual-access-artwork-pictures-development',
  VITE_ARTWORK_IMG_PROXY_BUCKET: 's3://arcual-access-artwork-pictures-development',
  VITE_DOCUMENTS_IMG_PROXY_BUCKET: 's3://arcual-access-artwork-documents-development',

  VITE_SENTRY_INGEST_URL:
    'https://8aa8ff085fbcbcf4a7cbd1ad03bc07f9@o4510986579607552.ingest.de.sentry.io/4510997902458960',

  // Feature flags (TODO: make server side)
  VITE_FEATURE_EDITIONS_ENABLED: true,
  VITE_FEATURE_DASHBOARD_ANALYTICS_ENABLED: true,

  VITE_FEATURE_SENTRY_ENABLED: true,
  VITE_FEATURE_SENTRY_CUSTOMER_FEEDBACK_ENABLED: false,

  // TODO remove once price visibility selection is implemented
  VITE_FEATURE_HIDE_PRICE_VISIBILITY_ID: '3514eaa8-9b94-480a-a3ce-ddfd275d63db',

  VITE_FUTURE_FAIR_ACTIVATION_ID: 'cf9965ef-4d0b-4f8c-9031-556d48080050',
  VITE_FUTURE_FAIR_ACTIVATION_ID_2: '7ae1b8c3-28f9-4ab0-b0e1-69c174738711',

  // checkout application
  VITE_CHECKOUT_DOMAIN: 'https://checkout.development.arcual.app/',

  // TODO: replace with server side request to get the images
  // CORS image request proxy service
  VITE_CORS_PROXY: 'https://ma3yb18hc8.execute-api.eu-central-1.amazonaws.com/development/cors-proxy?url=',
  VITE_AMPLITUDE_CLIENT_KEY: 'client-GOyrU5sqzIh4qv3l4caiutDqJFHxjdVj',
  VITE_USETIFUL_TOKEN: null,

  // Analytics
  VITE_GOOGLE_TAG_MANAGER_ID: '',
  VITE_CLARITY_PROJECT_ID: '',
};
